const WebSiteSchema = {
  "@type": "WebSite",
  "@id": "https://onbbits.io/#website",
  "url": "https://onbbits.io/",
  "name": "ONBBITS",
  "publisher": {
    "@id": "https://onbbits.io/#organization"
  }
};

export default WebSiteSchema;